import React, { FC } from 'react';
import { paths } from 'routing';
import { CampaignListPage } from 'pages/CampaignPage/CampaignListPage';
import { CampaignEditPage } from 'pages/CampaignPage/CampaignEditPage';
import { IndexPage } from 'pages/common/IndexPage';

export const CampaignPage: FC = () => (
  <IndexPage
    listPath={paths.CAMPAIGN_LIST}
    editPath={paths.CAMPAIGN_EDIT}
    newPath={paths.CAMPAIGN_NEW}
    listComponent={CampaignListPage}
    editComponent={CampaignEditPage}
  />
);
